export const handlePageReload = () => {
  // eslint-disable-next-line no-alert
  const reload = window.confirm(
    'There appears to be a new version of FareHarbor Desk. A page reload is required to continue.',
  );
  if (reload) {
    window.location.reload();
  }
};
